<template>
    <div class="specials-list-section">
        <!--layout1 13专题 -->
        <van-row
            class="specials-list-section-box"
            @click="goDetail(dataItem)"
        >
            <div class="specials-list-section-left">
                <van-image
                    fit="cover"
                    class="specials-list-section-left-img"
                    :src="dataItem.cover_img"
                    width="100%"
                    height="100%"
                />
<!--                <div class="specials-list-section-left-top" v-if="dataItem.top == 1">-->
<!--                    <img src="/static/v4/tag_top.svg" alt="" />-->
<!--                </div>-->
                <div class="specials-list-section-left-zl">
<!--                    {{ dataItem.type_text }}-->
                  <img src="/static/v4/icon_list_tag_column.svg" alt="" />
                </div>
            </div>
            <div class="specials-list-section-right">
                <div class="specials-list-section-right-title" v-html="dataItem.title">
                </div>
                <div class="specials-list-section-right-detail">
                    <div>
                        <!-- {{ dataItem.created_at }}-->
                        <span>{{ dataItem.view_count }}人阅读</span>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </van-row>
    </div>
</template>

<script>
import mixins from './mixin'
import Interface from '@/util/interface'
export default {
    mixins: [mixins],
    props: {
        dataItem: {
            type: Object,
            required: true
        }
    },
    methods: {
      goDetail(dataItem) {
          console.log(dataItem)
        this.$router.push({ name: 'topic-detail', params: { id: dataItem.id } })
        Interface.getData('get', `/course-phase/api/recommend_v2/${dataItem.id}/view`)
        Interface.getData('get', `/course/api/content_relation/${dataItem.id}/view`)
        Interface.mFootPrint(dataItem.origin_id,13,0,5,0, dataItem.title)
      }
    }
}
</script>

<style lang="scss" scoped>
.specials-list-section {
    border-bottom: 1px solid #f2f2f2;
    padding: 10px 12px;
    background-color: #ffffff;
    margin: 10px 10px;
    border-radius: 10px;

    .specials-list-section-top {
        border-radius: 6px;
        position: relative;

        .top-tag {
            top: 0;
            left: 0;
            position: absolute;
        }

        .specials-list-section-title-box {
            .specials-list-section-title {
                font-family: PingFangSC-Semibold;
                font-size: 16px;
                color: #ffffff;
                letter-spacing: 0;
                margin: 3px 15px;

            }

            .specials-list-section-info {
                font-family: Helvetica;
                font-size: 13px;
                color: #ffffff;
                letter-spacing: 0;
                margin-left: 15px;
                float: left;
                margin-bottom: 12px;
                margin-top: 12px;
            }

            .specials-list-section-icon {
                float: right;
                margin-right: 15px;
                margin-bottom: 12px;
            }

            box-sizing: border-box;
            position: absolute;
            bottom: 0px;
            width: 100%;
            background-image: linear-gradient(180deg, rgba(51, 51, 51, 0) 0%, rgba(0, 0, 0, 0.4) 99%);
            border-radius: 0 0 6px 6px;
        }

        .specials-list-section-desc {
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            color: #ffffff;
            letter-spacing: 0.5px;
            line-height: 24px;
            position: absolute;
            padding: 0 6px;
            bottom: 0px;
            left: 15px;
            font-weight: 500;
            margin-bottom: 10px;
        }

        .specials-list-section-box {
            padding: 0;
            height: 188px;
            width: 100%;
        }
    }

    &-box {
        width: 345px;
        // padding: 18px 0;
        // border-bottom: 1px solid #f2f2f2;
    }

    &-left {
        width: 130px;
        height: 73px;
        float: left;
        position: relative;
        border-radius: 6px;
        &-img {
            width: 112px;
            height: 66px;
            //background: #EFF3FA;
            border-radius: 6px;
            >>> .van-image__img,
            img {
                border-radius: 6px;
            }
        }
        &-zl {
            position: absolute;
            top: 0;
            left: 0;
            &.active {
                background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
                border-radius: 6px 3px 3px 3px;
            }
            img {
                width: 32px;
                height: 18px;
            }
        }
    }

    &-right {
        float: left;
        margin-left: 14px;
        width: 193px;
        text-align: left;
        height: 73px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        &-time {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #0fb7ad;
            letter-spacing: 0;

            background: #e6fdf6;
            border-radius: 4px;
            display: inline-block;
            padding: 2px 6px;
        }

        &-title {
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #222222;
            letter-spacing: 0;
            font-weight: 500;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            /deep/ .light {
              color: #D81D20;
            }
        }

        &-detail {
            margin-top: 14px;
            width: 100%;
            font-size: 12px;
            color: #979799;
            div {
                display: inline-block;
            }
        }

        .specials-list-section-info {
            margin-top: 8px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #9a9a9a;
            letter-spacing: 0;
        }
    }

    .specials-list-section {
        padding-bottom: 0px;
        .specials-list-section-box {
            border-bottom-width: 0px;
            padding-bottom: 0px;
            .specials-list-section-left-img {
                width: 130px;
                height: 73px;
            }
            .specials-list-section-left-top {
                position: absolute;
                top: 4px;
                left: 4px;
                width: 18px;
                height: 18px;
                border-radius: 3px;
                img {
                    width: 18px;
                    height: 18px;
                    border-radius: 3px;
                }
            }
            .specials-list-section-right-detail {
                span {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #9d9d9d;
                    line-height: 17px;
                }
            }
        }
    }

    .specials-list-section-left-zl {
        position: absolute;
        top: 0px;
        left: 0px;
        //border-radius: 4px;
        //font-size: 11px;
        //font-family: HarmonyOS_Sans_SC_Bold;
        //color: #976730;
        //line-height: 16px;
        //padding: 1px 1.6vw;
    }
    .specials-list-section-left-top {
        position: absolute;
        top: 4px;
        left: 2px;
        width: 18px;
        height: 18px;
        border-radius: 3px;
        img {
            width: 18px;
            height: 18px;
            border-radius: 3px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/hotRecommend/layout1/special.vue